import React from 'react'
import { connect } from 'react-redux'

import { NavigationMenuKey } from '@store/constants'
import {
  MenuItemInterface,
  ProjectIdentity,
  RootStateTypeExtra,
} from '@store/types'

import { StatusFillSvg, ToolsSvg } from '@components/adgroup-svg/react'
import MENU_ITEMS from '@components/navigation/menu-items'

interface ComponentProps {
  projectIdentity: ProjectIdentity
}

const getContent: (menu: MenuItemInterface) => React.ReactNode = (menu) => {
  if (menu.key === NavigationMenuKey.SESSION_SETTINGS) {
    return (
      <div className="flex items-center gap-3 text-sm font-semibold uppercase tracking-[.85px] text-white drop-shadow-70">
        <StatusFillSvg size="s" className="h-10 w-10 fill-white" />
        {menu.label}
      </div>
    )
  }
  if (menu.key === NavigationMenuKey.TOOLS) {
    return (
      <div className="flex items-center gap-3 text-sm font-semibold uppercase tracking-[.85px] text-white drop-shadow-70">
        <ToolsSvg size="s" className="h-10 w-10 fill-white" />
        {menu.label}
      </div>
    )
  }
  return menu.label
}

function Settings({ projectIdentity }: ComponentProps) {
  const settingsMenuItems = React.useMemo(() => {
    const footerMenus = MENU_ITEMS.filter(
      (item: MenuItemInterface) => item.active && item.type === 'footer-menu'
    )

    return footerMenus.map((footerMenu: MenuItemInterface) => {
      const myItem = projectIdentity.navigationSettings.find(
        (navItem: MenuItemInterface) => navItem.key === footerMenu.key
      )
      return { ...footerMenu, label: myItem?.label || footerMenu.label }
    })
  }, [projectIdentity.navigationSettings])

  return (
    <div className="flex flex-col gap-7 text-white">
      {settingsMenuItems.map(
        (item: MenuItemInterface) =>
          item.render &&
          item.render({
            menu: item,
            key: item.key,
            content: getContent(item),
          })
      )}
    </div>
  )
}

export default connect(({ projectIdentity }: RootStateTypeExtra) => ({
  projectIdentity,
}))(Settings)
